<template>
  <div class="contentDetails">
    <NavBar :navBlock='navBlock' :navtitle='navtitle' :pageBack='true'></NavBar>
    <div class="detailsContent">
        <Calendar :type='type' :id='id'></Calendar>
    </div>
  </div>
</template>

<script>
import NavBar from '@/components/navBar';
import Calendar from '@/components/calendar';
export default {
  data () {
    return {
      navBlock: '活動  /  行事曆列表',
      navtitle:'新增行事曆',
      type:'add',
      id: this.$route.query.id
    }
  },
  components: {
    NavBar,
    Calendar
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/activity/addCalendar.vue